import '../App.css';
import '../Tileandpopout.css';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

const Project = () => {
    const [work, setWork] = useState({pictures: null})
    const [startPasswordAnim, setStartPasswordAnim] = useState(false)
    const [passwordComplete, setPasswordComplete] = useState(false)

    const inputRef = useRef(null)
    const location = useLocation()

    useEffect(() => {
        const loadData = async () => {
        await fetch(`${process.env.PUBLIC_URL}/userdata/work${location.pathname}/details.json`, {headers: {"Content-Type": "application/json"} }).then((d) => {return d.json()}).then( (d) => setWork(d) );
        }
        loadData();
        console.log(work)
    }, [])

    const showContent = async () => {
        setPasswordComplete(true)
    }

    const handlePassword = (userInput) => {
        if(userInput === work.password){
            setStartPasswordAnim(true)
            setTimeout(showContent, 1250)
        }
    }

    const focus = () => {
        inputRef.current.focus()
    }

    return(
        <div className='tabs-border'>

        {(work.pictures !== null && work.password !== '' && !passwordComplete) ?
            <div className='project-pass' onClick={focus}>
                <div className='project-pass-body'>
                    <p className='project-pass-prompt'>Enter Password</p>
                    <input onChange={e => handlePassword(e.target.value)} autoFocus={true} ref={inputRef} className='project-pass-entry' disabled={startPasswordAnim} />
                </div>
            </div>
        :
            work.pictures ? work.pictures.map( (item, index) => (
                <img src={ '/userdata/work/'+ work.dir + '/'+ item } className='project-slide' key={index} loading='lazy' alt='project slide' />
            )) : <p>loading</p>
        }
        {(work.videolink !== "" && "videolink" in work && work.videotype === "Vimeo") && 
            <div className='project-slide'>
                <div className='vimeo-player' style={{position: "relative"}}><iframe src={work.videolink} frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style={{position: "absolute", top: 0, left:0, width:"100%", height:"100%"}} title="Nerf Dog Glow Airstrike"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
            </div>
        }

        </div>
    )

}

export default Project;